import { createFileRoute } from '@tanstack/react-router'
import { CorporateBookings } from '@/features/corporate-portal'

export const Route = createFileRoute('/corporate_/bookings')({
  component: CorporateBookings,
})
